import { render, staticRenderFns } from "./inquire.vue?vue&type=template&id=c6e6a16a&scoped=true&"
import script from "./inquire.vue?vue&type=script&lang=js&"
export * from "./inquire.vue?vue&type=script&lang=js&"
import style0 from "./inquire.vue?vue&type=style&index=0&id=c6e6a16a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e6a16a",
  null
  
)

export default component.exports